import axios from 'axios';
import { utilityService } from '@/services/utilityService.js';

function __searchForUser (term) {
    return axios.post(utilityService.getApiUrl('user/search/'),
        { Search: term },
        // Third parameter is the configuration object
        {
            headers: utilityService.getHeaders()
        }
    );
}

function __getUsersForOffice (officeId) {
    return axios.get(utilityService.getApiUrl(`user/office/${officeId}`),
        // Third parameter is the configuration object
        {
            headers: utilityService.getHeaders()
        }
    );
}

function __getVolumeConfig () {
    return axios.get(utilityService.getApiUrl(`user/currentVolume`),
        // Third parameter is the configuration object
        {
            headers: utilityService.getHeaders()
        }
    );
}

export const userService = {
    searchForUser: (term) => __searchForUser(term),
    getUsersForOffice: (officeId) => __getUsersForOffice(officeId),
    getVolumeConfig:() => __getVolumeConfig(),
};
